<template>
    <Modal @close="$emit('close')">
        <template v-slot:header>
            {{ __('New Billing Address') }}
        </template>
        <new-billing-address-form
            :countries="countries"
            @created="$emit('created', $event)"
        />
    </Modal>
</template>

<script>
import Modal from '../../../Modal'

export default {
    name: 'CreateBillingAddressModal',
    components: { Modal },

    props: {
        countries: {
            type: Array,
            required: true
        }
    }
}
</script>
